import React, { useMemo } from 'react';

import { useTranslation } from '../i18n';

import { getCountryFlag } from '../config/countries';

import { StaticPageLayout } from '../layouts/static-page.layout';

import { Layout, Card } from '../components/element';
import { H1, Subtitle, Text } from '../components/page';
import { FeedBack } from '../components/feedback';

const MapBox: React.FC = () => {
  const src =
    'https://www.google.com/maps/embed/v1/place?q=place_id:ChIJU1sqOZa9oRQRTBJmFy5eYpk&key=AIzaSyCIqSNzEdWR4CPsNJR__pGRkBSY69Td1Ho';

  return (
    <Card className="is-hover-shadow">
      <iframe
        src={src}
        style={{ border: '0' }}
        title="SmartPost"
        width="100%"
        height="440"
        frameBorder="0"
        allowFullScreen
      />
    </Card>
  );
};

const MainOffice = () => {
  const [t] = useTranslation('contacts');

  const officeSchedule: string[] = t('contacts:contacts.office.schedule') || [];
  const supportSchedule: string[] = t('contacts:contacts.support.schedule') || [];

  return (
    <div className="mb-20">
      <Subtitle>{t('contacts:contacts.subtitle')}</Subtitle>
      <div className="mt-10 mb-20">
        <Text txt={t('contacts:contacts.address')} />
      </div>

      <Layout.Row gutter={20}>
        <Layout.Col span={24} sm={12}>
          <Subtitle>{t('contacts:contacts.office.title')}</Subtitle>

          <ul>
            {supportSchedule.map((period, key) => (
              <li key={key.toString()}>{period}</li>
            ))}
          </ul>
        </Layout.Col>
        <Layout.Col span={24} sm={12}>
          <Subtitle>{t('contacts.support.subtitle')}</Subtitle>

          <ul>
            {officeSchedule.map((period, key) => (
              <li key={key.toString()}>{period}</li>
            ))}
          </ul>
        </Layout.Col>
      </Layout.Row>
    </div>
  );
};

const CountryFlag: React.FC<{ code: string }> = ({ code, children }) => {
  const flag = useMemo(() => getCountryFlag(code), [code]);

  const phoneNumber = useMemo(() => String(children).split(' ').join(''), [children]);

  return (
    <div className="d-flex align-items-center mb-10">
      {flag && <img style={{ width: '20px' }} src={flag} alt={code} />}
      <span className="ml-10">
        <a href={`tel:${phoneNumber}`}>{children}</a>
      </span>
    </div>
  );
};

const SupportInfo = () => {
  const [t] = useTranslation('contacts');

  return (
    <div>
      <div className="mb-10">
        <Subtitle>{t('contacts.support.title')}</Subtitle>
      </div>

      <div className="mb-20">
        <Layout.Row gutter={20}>
          <Layout.Col span={24} sm={12}>
            <CountryFlag code="gr">+30 210 9243 008</CountryFlag>
            <CountryFlag code="it">+39 02 8974 5885</CountryFlag>
            <CountryFlag code="cy">+357 2505 6922</CountryFlag>
            <CountryFlag code="pl">+48 222 662 177</CountryFlag>
          </Layout.Col>

          <Layout.Col span={24} sm={12}>
            <CountryFlag code="uk">+44 204 5770 711</CountryFlag>
            <CountryFlag code="ua">+38 044 3794 933</CountryFlag>
            <CountryFlag code="ru">+7 495 1339 241</CountryFlag>
            <CountryFlag code="de">+49 30 23599176</CountryFlag>
          </Layout.Col>
        </Layout.Row>
      </div>
    </div>
  );
};

const ContactsPage = () => {
  const [t] = useTranslation('contacts');

  return (
    <StaticPageLayout>
      <Layout.Row gutter={20}>
        <Layout.Col span={24} sm={14} md={16} lg={16}>
          <H1>{t('contacts:contacts.title')}</H1>
          <MainOffice />
          <SupportInfo />
          <div className="mb-20">
            <MapBox />
          </div>
        </Layout.Col>

        <Layout.Col span={24} sm={10} md={8} lg={8}>
          <FeedBack />
        </Layout.Col>
      </Layout.Row>
    </StaticPageLayout>
  );
};

ContactsPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'contacts'],
});

export default ContactsPage;
